import { render } from "./CategoriesPage.vue?vue&type=template&id=aeb521c0&scoped=true"
import script from "./CategoriesPage.vue?vue&type=script&lang=js"
export * from "./CategoriesPage.vue?vue&type=script&lang=js"

import "./CategoriesPage.vue?vue&type=style&index=0&id=aeb521c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aeb521c0"]])

export default __exports__